{
    "errors": {
        "required_field": "This is a required field",
        "invalid_field": "Invalid field value",
        "invalid_email": "Invalid email",
        "invalid_first_name":"Invalid first name",
        "invalid_last_name":"Invalid last name",
        "invalid_phone_number": "Phone number is invalid, please try again.",
        "server_error": "Something isn't working as it should. Please try again later.",
        "referral_used_error": "Sorry, you've already signed up with a different referral link.",
        "existing_user_error": "Sorry, you've already signed up.",
        "invalid_date_format": "Please enter a valid date in MM-DD-YYYY format",
        "invalid_date_format_YYYY": "Please enter a valid date in YYYY-MM-DD format",
        "pages": {
          "page_not_found": "Page not found",
          "page_not_found_description": "Uh-oh. The page you're looking for doesn't seem to be here.",
          "page_error": "Page error",
          "page_error_description": "Oops, something's not quite right.",
          "suggested_pages": "We suggest you check out one of these pages:"
        },
        "required_message": "{field} is required",
        "invalid_message": "Please enter a valid {field}",
        "generic_error": "An unknown error occurred"
      }
}